import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, Chip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import ErrorBanner from '../../common/ErrorBanner';
import { getVoiceAcdQueues } from '../../../api/backendApi';

const columns = [
  { field: 'name', headerName: 'Queue Name', flex: 1, minWidth: 220 },
  { field: 'activeCalls', headerName: 'Active Calls', width: 140, type: 'number' },
  { field: 'agentsAvailable', headerName: 'Agents Available', width: 160, type: 'number' },
  { field: 'avgWaitSec', headerName: 'Avg Wait (s)', width: 140, type: 'number' },
  {
    field: 'util',
    headerName: 'Utilization',
    width: 140,
    sortable: false,
    filterable: false,
    renderCell: (params) => {
      const calls = Number(params.row.activeCalls || 0);
      const max = Math.max(Number(params.row.agentsAvailable || 0), 10);
      const pct = Math.min(100, Math.round((calls / (max || 1)) * 100));
      let color = 'default';
      if (pct >= 80) color = 'error';
      else if (pct >= 50) color = 'warning';
      else color = 'success';
      return <Chip size="small" color={color} label={`${pct}%`} />;
    }
  },
  { field: 'updatedAt', headerName: 'Updated At', width: 200 },
];

const AcdQueuesTab = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      setError(null);
      const data = await getVoiceAcdQueues();
      const shaped = (Array.isArray(data) ? data : []).map((x, idx) => ({ id: x.id || idx, ...x }));
      setRows(shaped);
    } catch (e) {
      setError(e?.message || 'Failed to load ACD queues');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 30000); // 30s
    return () => clearInterval(t);
  }, [load]);

  return (
    <Box>
      <ErrorBanner message={error} />
      <div style={{ height: 520, width: '100%' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          loading={loading}
          disableRowSelectionOnClick
          density="compact"
          pageSizeOptions={[10, 25, 50]}
          initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        />
      </div>
    </Box>
  );
};

export default AcdQueuesTab;
